export default __webpack_public_path__ + "static/media/image-nota.f3c39504.png";